import React, { useEffect, useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { AiFillCloseCircle } from "react-icons/ai";
import { FaFilePdf, FaYoutube } from "react-icons/fa";
import animation from "../../../../images/jm-animation.gif";
// import "../../../CommunicationHub/MarketOutlook.css"
// import "./Calendar.css"
import "../../FinQSection/Calendar/Calendar.css"
import CalendarImg1 from "../../../../images/JM year end ppt 2025 V4.jpg"
import TradeChronics from "../../../../PDF/(JM) India Trade Calendar Information.pdf"
import FromNoise from "../../../../PDF/From Noise (2025) to Narrative (2026) - JM Financial Mutual Fund.pdf"
import { color } from "@amcharts/amcharts5";
import FinQBanner from "../../FinQBanner/FinQBanner";
import PdfIcon from '../../../../images/newIcon/PDF icon 1.svg'


function Outlook2026() {

  const [show, setShow] = useState(false);
  const [videoLink, setVideoLink] = useState("");
  const [videoTitle, setVideoTitle] = useState("");

  // const [pathname, setPathName] = useState("");

  //   useEffect(() => {
  //     var pathname = window.location.pathname;
  //     const regEx = new RegExp("-", "g");
  //     const resultName = pathname.replace(regEx, " ");
  //     setPathName(resultName);
  //   });
  


  const data = [
    {
      CommunicationID: 1,
      Title: "From Noise to Narrative (2026)",
      ThumbnailImage: CalendarImg1,
      PdfLink: FromNoise,
    //   YoutubeLink: "https://www.youtube.com/embed/8e8gI5duHNk?si=Bt7qjhaOQvrFtXCn",
    },
  ];

  const handleYoutubeClick = (link, title) => {
    setVideoLink(link);
    setVideoTitle(title);
    // setShow(true);
  };

  const handleClosePopup = () => setShow(false);

  return (
    <>
      {/* <FinQBanner /> */}
{/* 
      <Container>
                <Row>
                  <Col>
                    <ul className="navigator-arrow">
                      <li>
                        <a href="/">
                          <i className="fa fa-home" aria-hidden="true"></i>
                        </a>{" "}
                        <i className="fa fa-angle-right" aria-hidden="true"></i>
                      </li>
                      <li>
                        <a href="/Insights">
                          <i>Insights</i>
                        </a>{" "}
                        <i className="fa fa-angle-right" aria-hidden="true"></i>
                      </li>
                      {/* <li>Calculator</li><i className="fa fa-angle-right" aria-hidden="true"></i> 
                    
                      {window.location.pathname !== "/Insights" ? (
                        <li>{pathname.split("/")[2]}</li>
                      ) : (
                        ""
                      )}
                    </ul>
                  </Col>
                </Row>
              </Container> */}
              
      <section className="market-outlook-section">

        <Container>
          <Row>
            <Col sm={12} style={{ padding: 0 }}>
              <div className="market-outlook-container">
                {data?.map(({ Title, ThumbnailImage, PdfLink, YoutubeLink, CommunicationID }) => (
                  <div className="market-outlook-item zoom" key={CommunicationID}>
                    <h3>{Title}</h3>

                    {/* Thumbnail */}
                    {/* <span onClick={() => handleYoutubeClick(YoutubeLink, Title)}> */}
                    <span>
                      <img src={ThumbnailImage} className="img-fluid" alt="Thumbnail" />

                    </span>
                    {/* <p style={{fontSize: "0.9rem"}}>
                      We are celebrating India’s entrepreneurial spirit, its cultural richness, and its unwavering march toward global leadership. 
                      This serves as a daily reminder of who we are, where we come from, and the limitless possibilities that lie ahead. 
                      Let it inspire pride in our heritage, purpose in our present, and faith in India’s destined future.
                    </p> */}
                    

                    {/* Icons section below */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "20px",
                        marginTop: "10px",
                      }}
                    >
                      <a
                        href={PdfLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pdf-icon"
                        style={{
                          color: "#d32f2f",
                          transition: "transform 0.3s ease, opacity 0.3s ease",
                        }}
                         aria-label={`Download PDF: ${Title}`}
                      >
                          <img
                        src={PdfIcon}
                        alt="PDF"
                        width={28}
                        height={28}
                        style={{
                          cursor: "pointer",
                          transition: "transform 0.3s ease, opacity 0.3s ease",
                        }}
                      />
                      
                      </a>
                      {/* <a href={YoutubeLink} style={{ cursor: "pointer" }} target="_blank">
                        <FaYoutube size={24} color="#ff0000" title="Watch on YouTube" />
                      </a> */}
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* YouTube modal */}
      {/* <Modal show={show} className="modal modal-teams" onHide={handleClosePopup}>
        <Modal.Body id="modal_info">
          <div className="btnDiv">
            <div onClick={handleClosePopup}>
              <AiFillCloseCircle className="btncl" />
            </div>
          </div>
          <div className="youtubepopup">
            <p>{videoTitle}</p>
            <div>
              <iframe
                className="iframe-vdo"
                src={videoLink}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </Modal.Body>
      </Modal> */}
    </>
  );
}

export default Outlook2026;
